import React, { useEffect, useState } from "react";
import "./SelectUnselectExtended.css";
import Price from "src/components/Price/Price";
import { toEuro, toEuroRound } from "src/helpers/calculation";
import { usePopup } from "src/contexts/PopupContext";

export interface SelectUnselectExtendedProps {
  name: string;
  imageUrl?: string;
  color?: string;
  price?: number;
  description?: string;
  Component?: React.FC;
  isSelected: boolean;
  onSelect: () => void;
  onUnselect: () => void;
  alwaysShowSelected?: boolean;
  selectedNames?: string;
  parentIsSelected?: boolean;
  carouselImages?: string[];
}

const SelectUnselectExtended: React.FC<SelectUnselectExtendedProps> = ({
  name,
  imageUrl,
  color,
  price,
  description,
  Component,
  isSelected,
  onSelect,
  onUnselect,
  alwaysShowSelected,
  selectedNames,
  parentIsSelected,
  carouselImages,
}) => {
  const [isTabOpen, setIsTabOpen] = useState(false);
  const [showDetails, setShowDetails] = React.useState(false);
  const [showComponent, setShowComponent] = React.useState(false);

  const { setIsCarouselVisible, setCarouselImages } = usePopup();

  const highlight =
    parentIsSelected !== undefined
      ? parentIsSelected && isSelected
      : isSelected;

  const handleDetailseClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation(); // Prevent the container click event from being triggered
    setIsTabOpen(!isTabOpen);
  };

  let selectedVisible = isSelected;
  if (alwaysShowSelected) selectedVisible = true;

  useEffect(() => {
    // setShowComponent(isSelected);
    // console.log(isSelected);
  }, [isSelected]);

  const handleClick = () => {
    if (isSelected) {
      onUnselect();
      setShowComponent(!showComponent);
    } else {
      onSelect();
      setShowComponent(!showComponent);
    }
  };
  const ArrowIcon: React.FC = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 12L10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12Z"
        fill="currentColor"
      />
    </svg>
  );

  if (!color && !imageUrl) color = "#9BFFBE";

  return (
    <div
      className={`common-option-container ${
        highlight && (!showComponent || !Component) ? "active_bg" : ""
      } ${highlight ? "active" : ""}`}
      onClick={handleClick}
    >
      {/* <div className="common-option-check"></div> */}
      <div className="common-option">
        <div
          className={`common-option-thumb${
            (imageUrl && !imageUrl.includes("empty")) || carouselImages
              ? " cursor"
              : ""
          }`}
          style={{ backgroundColor: color }}
          onClick={(event) => {
            if (carouselImages) {
              event.stopPropagation();

              setCarouselImages(carouselImages);
              setIsCarouselVisible(true);
            } else if (imageUrl && !imageUrl.includes("empty")) {
              event.stopPropagation();

              setCarouselImages([imageUrl]);
              setIsCarouselVisible(true);
            }
          }}
        >
          {imageUrl ? <img src={imageUrl} alt={imageUrl} /> : <></>}
        </div>
        <div className="details_container">
          <div className="details_text">
            <div className={`lable  ${highlight ? "active" : ""}`}>{name}</div>
            {price ? (
              <div className="price">{price > 0 ? toEuroRound(price) : ""}</div>
            ) : (
              <></>
            )}
          </div>
          <div className="details_childs">
            <span>{selectedVisible ? selectedNames : null}</span>
            <div className="details_buttons">
              {description && (
                <div
                  className={`details ${showDetails ? "open" : ""}`}
                  onClick={(event) => {
                    setShowDetails(!showDetails);
                    event.stopPropagation();
                  }}
                >
                  <span>Details</span>
                </div>
              )}
              {Component ? (
                <div
                  className={`details_icon ${showComponent ? "open" : ""}`}
                  onClick={(event) => {
                    setShowComponent(!showComponent);
                    event.stopPropagation();
                  }}
                >
                  <ArrowIcon />
                </div>
              ) : (
                false
              )}
            </div>
          </div>
        </div>
      </div>
      {description && showDetails && (
        <div className="description">{description}</div>
      )}
      {Component && showComponent && (
        <div className="value">
          <div className="component">{<Component />}</div>
        </div>
      )}
    </div>
  );
};

export default SelectUnselectExtended;
